export default __webpack_public_path__ + "static/media/greenLady.da5ddef7.webp";